module.exports = __webpack_public_path__ + "media/images/Ciratas_SecondaryLogo-17cb335619204e3fb469454ff8186e22.png";